import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const GotherPackIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "GotherPackGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M12.2871 21.9998C12.1334 21.9998 11.9836 21.9371 11.8749 21.8275L2.89413 12.8487C2.66892 12.6206 2.66892 12.2525 2.89119 12.0273L10.6054 4.31444C13.3084 1.61034 17.7072 1.61034 20.4102 4.31444C21.7198 5.62341 22.4409 7.36415 22.4409 9.21649C22.4409 11.0679 21.7198 12.8086 20.4102 14.1185L12.6989 21.8285C12.6044 21.9224 12.4482 22.0047 12.2871 21.9998ZM3.89971 12.4365L12.2871 20.822L19.7012 13.4097C20.8214 12.2897 21.4383 10.7996 21.4383 9.21649C21.4383 7.6324 20.8214 6.14329 19.7012 5.02327C17.3895 2.71176 13.6281 2.71176 11.3143 5.02327L3.89971 12.4365Z"
        fill="#459947"
      />
      <path
        d="M18.6046 6.62106C18.4763 6.62106 18.3481 6.5721 18.2501 6.47421C18.0543 6.2784 18.0543 5.96119 18.2501 5.76538L21.8691 2.14685C22.0649 1.95105 22.3822 1.95105 22.578 2.14685C22.7738 2.34266 22.7738 2.65987 22.578 2.85568L18.959 6.47421C18.8611 6.57211 18.7329 6.62106 18.6046 6.62106Z"
        fill="#459947"
      />
      <path
        d="M17.3606 9.18614C16.8935 9.18614 16.4265 9.00893 16.071 8.65354C15.3607 7.94179 15.3607 6.78456 16.071 6.07476C16.7819 5.36495 17.9388 5.363 18.6496 6.07476C19.36 6.78456 19.36 7.94178 18.6501 8.65354C18.2947 9.00893 17.8271 9.18614 17.3606 9.18614ZM17.3606 6.54371C17.1501 6.54371 16.94 6.62399 16.7799 6.78358C16.4603 7.10373 16.4603 7.62457 16.7804 7.94471C17.0996 8.26388 17.6206 8.26388 17.9407 7.94471C18.2604 7.62456 18.2604 7.10372 17.9407 6.78358C17.7806 6.62399 17.5706 6.54371 17.3606 6.54371Z"
        fill="#459947"
      />
      <path
        d="M14.8028 10.1267C14.1839 10.1267 13.6014 10.2834 12.983 10.9188L10.52 13.3053C10.1894 13.6165 9.90446 13.7175 9.64693 13.7175C8.99051 13.7175 8.5496 13.2538 8.5496 12.5635C8.5496 11.8731 8.99074 11.4091 9.64693 11.4091C10.2108 11.4091 10.5609 11.7914 10.6957 12.2779C10.7088 12.3253 10.7631 12.342 10.7973 12.3091L11.8802 11.2638C11.9034 11.2416 11.9166 11.2097 11.9166 11.1763V10.0672C11.9166 10.028 11.8856 9.99708 11.8492 10.0002L10.6252 10.1052C10.5908 10.1081 10.5652 10.1402 10.5678 10.1772L10.5879 10.4567C9.83345 10.0196 9.03703 10.0462 8.43747 10.3735C7.69498 10.7599 7.22485 11.5673 7.22485 12.5632C7.22485 13.975 8.24353 14.9998 9.64693 14.9998C9.65277 14.9998 9.65839 14.9998 9.66423 14.9998C10.3105 14.9959 10.92 14.7657 11.6611 14.0043L13.9079 11.8318C14.2522 11.5211 14.4729 11.4091 14.8028 11.4091C15.454 11.4091 15.8916 11.8729 15.8916 12.5635C15.8916 13.254 15.454 13.7175 14.8028 13.7175C14.5367 13.7175 14.3057 13.6404 14.125 13.5023C14.0614 13.4559 13.7976 13.247 13.6652 12.8788C13.6493 12.8345 13.5976 12.821 13.565 12.8526L12.6922 13.7038C12.6701 13.7253 12.6654 13.7603 12.6803 13.7879C13.0881 14.5425 13.8744 15 14.8028 15C16.2062 15 17.2249 13.9753 17.2249 12.5635C17.2249 11.1516 16.2062 10.1267 14.8028 10.1267Z"
        fill="#459947"
      />
    </svg>
  );
};

export default GotherPackIcon;
